import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material";
import { Card } from "v2/components/base/Flex/ui";

interface DefinitionTooltipProps {
  term?: string;
  children: React.ReactNode;
  isShow: boolean;
  maxWidth?: string;
}

const DefinitionTooltip = ({ term, children, isShow, maxWidth }: DefinitionTooltipProps) => {
  const theme = useTheme();
  return isShow ? (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 3,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.7)",
        }}
      />
      <Card.Section
        sx={{
          minHeight: "200px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(2),
          position: "fixed",
          top: "50%",
          left: "50%",
          zIndex: 10,
          transform: "translate(-50%, -50%)",
          background: theme.palette.surface["container-bg"],
          borderRadius: theme.spacing(2),
          padding: theme.spacing(3),
          border: `1px solid #FFFFFF0D`,
          ...(maxWidth ? { maxWidth, width: "100%" } : { minWidth: "80%", width: "fit-content" }),
          "&:focus-visible": {
            outline: "none",
          },
        }}>
        {term ? (
          <Typography
            sx={{ width: "100%", textAlign: "center", textTransform: "capitalize" }}
            variant="mobile-h3">
            {term.toLowerCase()}
          </Typography>
        ) : null}
        {children}
      </Card.Section>
    </>
  ) : (
    <></>
  );
};

export default DefinitionTooltip;
